/**
 * @fileoverview API layer for KPI Asset settings. All endpoint knowledge for
 * this feature lives here; components call these named functions and never
 * assemble URLs themselves.
 */
import { apiCall } from "../../../_services/apiCall";
import config from "../../../config/config";

const COMPANY = config.POSTLOGIN_API_URL_COMPANY;
const MAPPINGS = `${COMPANY}kpiAssetSettings`;

export const getSources = () =>
  apiCall(`${COMPANY}getSource`, {}, {}, "GET");

export const getMappings = (fyid) =>
  apiCall(MAPPINGS, {}, { fyid }, "GET");

export const getEmissionKpiSettings = (fyid) =>
  apiCall(`${COMPANY}emissionKpiSettings`, {}, { fyid }, "GET");

export const getFrameworks = (userId) =>
  apiCall(`${COMPANY}getFramework`, {}, { type: "ALL", userId }, "GET");

export const getReportingQuestions = (financialYearId, frameworkIds) =>
  apiCall(
    `${COMPANY}getReportingQuestionnew`, {},
    { financialYearId, frameworkIds, fromSettings: false },
    "GET",
  );

export const saveMappings = (fyid, mappings) =>
  apiCall(MAPPINGS, {}, { fyid: Number(fyid), mappings }, "POST");

export const renameAsset = (id, assetTitle) =>
  apiCall(`${MAPPINGS}/${id}`, {}, { assetTitle }, "PATCH");

export const renameAssetsBulk = (ids, assetTitle) =>
  apiCall(`${MAPPINGS}/bulk/title`, {}, { ids, assetTitle }, "PATCH");

export const deleteAsset = (id) =>
  apiCall(`${MAPPINGS}/${id}`, {}, {}, "DELETE");

export const deleteAssetsBulk = (ids) =>
  apiCall(`${MAPPINGS}/bulk`, {}, { ids }, "DELETE");

export const copyMappings = (body) =>
  apiCall(`${MAPPINGS}/copy`, {}, body, "POST");
